module.exports = __webpack_public_path__ + "img/kihteva.911c4117.png";